import { UpdateGridRequest, UpdateGridResponse } from '../../types/plans/types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';

export const updateGrid = async (
  body: UpdateGridRequest
): Promise<{
  data: UpdateGridResponse;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }

  const url = `/resourceMatrix/insurance/update_grid?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as unknown as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    loading = false;
    return { data: responseData as UpdateGridResponse, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to update provider credential');
  }
};
